<nb-card>
    <nb-card-header>
        Complete Lesson Info
    </nb-card-header>
    <nb-card-body>
        <form [formGroup]="form">
            <div style="display: flex; flex-flow: row wrap; margin: 0.25rem;">
                <div style="display: flex; flex-flow: column nowrap;">
                    <label class="label" for="input-email">Name:</label>
                    <input [status]="$nameControl.invalid ? 'danger' : 'success'" formControlName='name'
                        style="margin: 0.25rem;" nbInput placeholder="name">
                </div>
                <div style="display: flex; flex-flow: column nowrap;">
                    <label class="label" for="input-email">Order:</label>
                    <input [status]="$indexControl.invalid ? 'danger' : 'success'" formControlName='index'
                        style="margin: 0.25rem;" type='number' nbInput placeholder="order">
                </div>
            </div>
            <nb-checkbox formControlName='is_published' style="margin: 0.5rem;" status="success">Publish</nb-checkbox>
            <nb-checkbox formControlName='is_free' style="margin: 0.5rem;" status="success">Free</nb-checkbox>
        </form>
    </nb-card-body>
    <nb-card-footer>
        <button style="margin-inline-end: 1rem;" class="cancel" nbButton ghost status="danger"
            (click)="cancel()">Cancel</button>
        <button nbButton status="success" (click)="submit()">Submit</button>
    </nb-card-footer>
</nb-card>